import { render, staticRenderFns } from "./CommentModule.vue?vue&type=template&id=31c6bd64&scoped=true&"
import script from "./CommentModule.vue?vue&type=script&lang=js&"
export * from "./CommentModule.vue?vue&type=script&lang=js&"
import style0 from "./CommentModule.vue?vue&type=style&index=0&id=31c6bd64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6bd64",
  null
  
)

export default component.exports